import React, { Component } from 'react';
import CargomaticModal from 'components/v2/modal';
import CargomaticTooltip from 'components/v2/Tooltip';
import { withTranslation } from 'react-i18next';
class AdminEditProfileModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user,
        };
    }
    handleChange(field) {
        return (e) => {
            const value = e.target.value;
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { user: Object.assign(Object.assign({}, prevState.user), { [field]: value }) });
            });
        };
    }
    renderBody() {
        const { t } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "grid grid-cols-4 gap-2" },
                React.createElement("div", { className: "col-span-2 sm:col-span-2" },
                    React.createElement("label", { className: "flex mb-2 form-label" },
                        t('FIRST_NAME'),
                        " *",
                        React.createElement(CargomaticTooltip, { id: "first_name", className: "ml-2" },
                            t('FIRST_NAME_REQUIRED'),
                            "!")),
                    React.createElement("input", { type: "text", placeholder: "John", className: "w-full mb-4 form-field", onChange: this.handleChange('first_name'), value: this.state.user.first_name })),
                React.createElement("div", { className: "col-span-2 sm:col-span-2" },
                    React.createElement("label", { className: "flex mb-2 form-label" },
                        t('LAST_NAME'),
                        " *",
                        React.createElement(CargomaticTooltip, { id: "last_name", className: "ml-2" },
                            t('LAST_NAME_REQUIRED'),
                            "!")),
                    React.createElement("input", { type: "text", placeholder: "Smith", className: "w-full mb-4 form-field", onChange: this.handleChange('last_name'), value: this.state.user.last_name }))),
            React.createElement("div", { className: "grid grid-cols-3 gap-2" },
                React.createElement("div", { className: "col-span-2 sm:col-span-2 " },
                    React.createElement("label", { className: "flex mb-2 form-label" },
                        t('EMAIL'),
                        " *",
                        React.createElement(CargomaticTooltip, { id: "email_id", className: "ml-2" },
                            t('EMAIL_IS_REQUIRED'),
                            "!")),
                    React.createElement("input", { type: "email", placeholder: "jsmith@cargomatic.com", className: "w-full mb-4 form-field", onChange: this.handleChange('email'), value: this.state.user.email })))));
    }
    renderFooter() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("button", { className: "button button-secondary", type: "button", onClick: () => this.hide() }, t('CANCEL')),
            React.createElement("button", { className: "button button-green", onClick: () => this.save() }, t('SAVE'))));
    }
    save() {
        this.props.onSave(this.state.user);
    }
    hide() {
        this.props.onHide();
    }
    render() {
        const { t } = this.props;
        return (React.createElement(CargomaticModal, { backdrop: "static", style: { top: '20%' }, dialogClassName: "modal-override-md", showCloseButton: true, title: t('EDIT_ACCOUNT'), show: this.props.show, body: this.renderBody(), footer: this.renderFooter(), onHide: () => this.hide() }));
    }
}
export default withTranslation()(AdminEditProfileModal);
